/* src/app/layout/authentication-layout/authentication-layout.component.scss */
.authentication-layout-container {
  font-family: "Open Sans", sans-serif;
  background: #0E3E32 url("./media/authentication-pages-bg.svg") center -110% no-repeat;
  min-height: 100%;
  padding-bottom: 50px;
}
.authentication-layout-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px 0 42px;
  color: #FFFFFF;
  font-size: 18px;
}
.authentication-layout-logo {
  display: inline-block;
  margin-bottom: 20px;
  width: 126px;
  height: 90px;
  background: url("./media/Alpi_2020_BW_F.png") 0 0 no-repeat;
}
/*# sourceMappingURL=authentication-layout.component.css.map */
